import React from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";
import { RequiredAsterisk } from "../professional/RequiredAsterisk";

const PhoneInputField = ({ value, onChange, errors, containerStyle = {}, disabled }) => {
  return (
    <PhoneInput
      country={"ke"}
      value={value}
      onChange={onChange}
      countryCallingCodeEditable={false}
      countryCodeEditable={false}
      enableAreaCodes={false}
      enableSearch={true}
      disableSearchIcon={false}
      disabled={disabled}
      inputProps={{
        name: "phone_number",
        required: true,
      }}
      placeholder="Enter Phone number"
      specialLabel={
        <span>
          Phone Number <RequiredAsterisk />
        </span>
      }
      containerStyle={{
        width: "100%",
        height: "55px",
        borderRadius: "4px",
        ...containerStyle,
      }}
      inputStyle={{
        width: "100%",
        height: "100%",
        fontSize: "16px",
        border: errors.phone_number
          ? "1px solid #d32f2f"
          : "1px solid rgba(209, 213, 219, 1)",
        borderRadius: "4px",
        fontFamily: "inherit",
        // Remove focus outline
        outline: "none",
        boxShadow: "none",
      }}
      // buttonStyle={{
      //   border: errors.phone_number ? '1px solid #d32f2f' : '1px solid rgba(209, 213, 219, 1)',
      //   borderRight: 'none',
      //   borderRadius: '4px 0 0 4px',
      //   backgroundColor: 'transparent',
      // }}
      dropdownStyle={{
        borderRadius: "4px",
      }}
      // Remove focus styles
      onFocus={(e) => {
        if (errors.phone_number) {
          // Remove blue focus border when there's an error
          e.target.style.boxShadow = "none";
          e.target.style.outline = "none";
          e.target.style.border = "1px solid #d32f2f";
        } else {
          // Keep normal focus behavior when no error
          e.target.style.border = "2px solid #1976d2";
        }
      }}
      onBlur={(e) => {
        // Reset to default border when focus is lost
        if (errors.phone_number) {
          e.target.style.border = "1px solid #d32f2f";
        } else {
          e.target.style.border = "1px solid rgba(209, 213, 219, 1)";
        }
      }}
    />
  );
};

export default PhoneInputField;
